module.exports = __webpack_public_path__ + "media/images/emblems/Blason_ville_suisse_Cornaux_(Neuchatel)-291fd41845d602f0328394fcca9adb3b.svg";